import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { DEFAULT_PX_TO_MM_DPI } from '../constants/phoneCase';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);

declare global {
  interface Window {
    opera: any;
  }
}

export const concatArrayString = (array: string[] = []) => {
  return array.join(', ');
};

export const getYoutubeId = (url: string) => {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
};

export const renderDate = (date: dayjs.Dayjs) => {
  return date.format('LL');
};

export const formatDate = (date: dayjs.Dayjs, type?: string) => {
  return date.format(type || 'Do MMM YY');
};

export const isValidEmbededLinks = (url: string) => {
  const regExp =
    /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
  return !!url.match(regExp);
};

export const getBase64 = (img: any, callback: any) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const convertBase64ToFile = (data: string, filename: string) => {
  const arr = data.split(','),
    bstr = atob(arr[1]);

  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  const types = arr[0].match(/:(.*?);/);
  if (!types || !types.length) {
    return null;
  }

  const mime = types[1];

  return new File([u8arr], filename, { type: mime });
};

export const isMobileDevice = () => {
  if (typeof window !== 'undefined') {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }
};

export const median = (arr: number[]) => {
  const mid = Math.floor(arr.length / 2),
    nums = [...arr].sort((a, b) => a - b);
  return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};

export const lowercaseAndRemoveSpace = (value: string): string => {
  return value.toLowerCase().replace(/\s+/g, '');
};

export const toCapitalizeFirstLetter = (str: string | undefined): string => {
  if (!str) {
    return '';
  }
  return !!str ? str[0].toUpperCase() + str.slice(1) : '';
};

export const roundUpTwoDecimals = (num: number): number => {
  return +num.toFixed(2);
};

const pxToMm = (px: number) => px / DEFAULT_PX_TO_MM_DPI;

// Convert dataURL to Blob for originalFile
const dataUrlToBlob = (dataUrl: string) => {
  const byteString = atob(dataUrl.split(',')[1]); // Decode base64
  const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0]; // Extract MIME type
  const arrayBuffer = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    arrayBuffer[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeString });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  concatArrayString,
  getYoutubeId,
  renderDate,
  formatDate,
  isValidEmbededLinks,
  getBase64,
  convertBase64ToFile,
  isMobileDevice,
  lowercaseAndRemoveSpace,
  toCapitalizeFirstLetter,
  roundUpTwoDecimals,
  pxToMm,
  dataUrlToBlob,
};
